import {
  ControlProps,
  isDescriptionHidden,
  OwnPropsOfEnum,
} from "@jsonforms/core";
import { withJsonFormsEnumProps } from "@jsonforms/react";
import { useMemo } from "react";

import Select from "@/components/elements/Select";
import { InputDescription } from "@/components/primitives/InputDescription";
import FieldLabel from "@/components/primitives/InputLabel";
import InputErrorTooltip from "@/components/elements/InputErrorTooltip";

type EnumControlProps = ControlProps & OwnPropsOfEnum;

function EnumControlComponent({
  data,
  handleChange,
  path,
  label,
  description,
  errors,
  options = [],
  visible,
  enabled,
  required,
  config,
}: EnumControlProps) {
  const showDescription = !isDescriptionHidden(
    visible,
    description,
    false,
    config?.showUnfocusedDescription,
  );
  const hasError = errors !== undefined && errors.length > 0;

  const selectedValue = useMemo(() => {
    if (data == null) return null;
    return options.find((opt) => opt.value === data) ?? null;
  }, [data, options]);

  if (!visible) return null;

  return (
    <div>
      <FieldLabel htmlFor={path} required={required}>
        {label}
      </FieldLabel>

      <div className="flex items-center">
        <div className="grow">
          <Select
            inputId={path}
            options={options}
            value={selectedValue}
            onChange={(opt: any) =>
              handleChange(path, opt ? opt.value : undefined)
            }
            disabled={!enabled}
          />
        </div>

        {hasError && (
          <InputErrorTooltip
            iconClassNames="w-6"
            error={label + " " + errors}
          />
        )}
      </div>

      {showDescription && description && (
        <InputDescription className="m-1">{description}</InputDescription>
      )}
    </div>
  );
}

export const EnumControl = withJsonFormsEnumProps(EnumControlComponent);
